module.exports = __webpack_public_path__ + "static/media/turbo-command-2017.6be381e0.png";